import React from 'react';
import { ReactComponent as LayersIcon } from '@src/assets/icons/layers.svg';
import { ArcCheckbox, ArcCollapse, ArcIconButton, ArcStack, ArcText, ArcTooltip } from '@src/core/ui';
import { LayersProps } from './types';
import { useDispatch, useSelector } from 'react-redux';
import { selectDisplayNoFlyZones, setDisplayNoFlyZones } from '@src/core/features';
import { selectDisplaySafeLandZones, setDisplaySafeLandZones } from '@src/core/features/zones/redux';
import { setRulerActive } from '@src/core/controllers/map/redux';
import { useDisclosure } from '@src/core/hooks';

const Layers: React.FC<LayersProps> = () => {
  const dispatch = useDispatch();
  const { open, toggle } = useDisclosure();

  const displayNoFlyZones = useSelector(selectDisplayNoFlyZones);
  const displaySafeLandZones = useSelector(selectDisplaySafeLandZones);

  // Interacting with another tool exits the ruler and clears its lines.
  const onToggle = () => {
    dispatch(setRulerActive(false));
    toggle();
  };
  return (
    <ArcStack sx={{ position: 'relative', overflow: 'visible' }}>
      <ArcStack
        width={50}
        height={50}
        borderRadius={2}
        alignItems='center'
        justifyContent='center'
        bgcolor='background.paper'>
        <ArcTooltip title='Layers'>
          <ArcIconButton onClick={onToggle}>
            <LayersIcon />
          </ArcIconButton>
        </ArcTooltip>
      </ArcStack>

      <ArcCollapse
        in={open}
        sx={{
          position: 'absolute',
          right: '100%',
          top: 0,
          mr: 1,
          zIndex: 2,
        }}>
        <ArcStack py={1} pl={1} pr={2} borderRadius={2} bgcolor='background.paper' sx={{ boxShadow: 2 }}>
          <ArcStack direction='row' alignItems='center' sx={{ whiteSpace: 'nowrap' }}>
            <ArcCheckbox
              size='small'
              color='brand'
              checked={displayNoFlyZones}
              onChange={(_, value) => {
                dispatch(setDisplayNoFlyZones(value));
              }} />
            <ArcText.h6>No-fly Zones</ArcText.h6>
          </ArcStack>
          <ArcStack direction='row' alignItems='center' sx={{ whiteSpace: 'nowrap' }}>
            <ArcCheckbox
              size='small'
              color='brand'
              checked={displaySafeLandZones}
              onChange={(_, value) => {
                dispatch(setDisplaySafeLandZones(value));
              }} />
            <ArcText.h6>Safe-land Zones</ArcText.h6>
          </ArcStack>
        </ArcStack>
      </ArcCollapse>
    </ArcStack>
  );
};

export default Layers;
